export default __webpack_public_path__ + "static/media/Front-Private-Palace-in-Hariss.f5d7bf3c.jpg";